import { ColorMode, extendTheme } from "@chakra-ui/react";

import { BORDER_WIDTHS } from "./consts/border-width-consts";
import { DEFAULT_COLORS, DEFAULT_DARK_COLORS } from "./consts/colors-consts";
import { INDICES } from "./consts/index-consts";
import { RADII } from "./consts/radius-consts";
import { SIZES } from "./consts/sizing-consts";
import { TEXT_SIZES } from "./consts/text-size-consts";
import { accordionTheme } from "./multipart-themes/accordion";
import { alertTheme } from "./multipart-themes/alert";
import { checkboxTheme } from "./multipart-themes/checkbox";
import { formTheme } from "./multipart-themes/form";
import { formErrorTheme } from "./multipart-themes/formError";
import { inputTheme } from "./multipart-themes/input";
import { MENU_ITEM_STYLE_SX, menuTheme } from "./multipart-themes/menu";
import { modalTheme } from "./multipart-themes/modal";
import { popoverTheme } from "./multipart-themes/popover";
import { radioTheme } from "./multipart-themes/radio";
import { sliderTheme } from "./multipart-themes/slider-theme";
import { switchTheme } from "./multipart-themes/switch";
import { tableTheme } from "./multipart-themes/table";
import { tabsTheme } from "./multipart-themes/tabs";
import { BUTTON_STYLES } from "./styles/button-styles";
import { FORM_LABEL_STYLES } from "./styles/form-label-styles";
import { HEADING_STYLES } from "./styles/heading-styles";
import { STEPPER_STYLES } from "./styles/stepper-styles";
import { MAPLIBRE_STYLES } from "./sx-styles/maplibre-sx-styles";
import { READONLY_SX_STYLES } from "./sx-styles/readonly-sx-styles";
import { SCROLLBAR_STYLES } from "./sx-styles/scrollbar-sx-styles";

export const getRanaTheme = (colorMode: ColorMode) =>
  extendTheme({
    // GLOBAL STYLINGS
    styles: {
      global: {
        ...MAPLIBRE_STYLES,
        ...SCROLLBAR_STYLES,
        ...READONLY_SX_STYLES,
        ...MENU_ITEM_STYLE_SX,
        "*": {
          borderColor: "brand.border",
        },

        "li::marker": {
          fontWeight: "bold",
          color: "brand.analytic",
        },
        strong: {
          color: "brand.analytic",
        },
        body: {
          background: "brand.grey.200",
          backgroundColor: "brand.grey.200",
          color: "brand.deep_sea",
        },
      },
    },

    // THEME CONSTANTS
    borderWidths: BORDER_WIDTHS,
    sizes: SIZES,
    space: SIZES,
    zIndices: INDICES,
    textStyles: TEXT_SIZES,
    fonts: {
      heading: "Roboto",
      body: "Roboto, sans-serif",
    },
    shadows: {
      default: "0px 0px 8px 0px rgba(44, 59, 69, 0.05)",
    },
    colors: colorMode === "light" ? DEFAULT_COLORS : DEFAULT_DARK_COLORS,

    radii: RADII,

    // COMPONENT STYLING
    components: {
      Text: {
        defaultProps: {
          fontWeight: "20px",
          color: "brand.deep_sea",
        },
      },

      // VARIANTS OR SIZES
      Heading: HEADING_STYLES,
      Button: BUTTON_STYLES,
      FormLabel: FORM_LABEL_STYLES,
      Stepper: STEPPER_STYLES,
      Tag: {
        baseStyle: {
          container: {
            bg: "brand.light_sky",
            color: "brand.deep_sea",
          },
        },
      },
      Textarea: {
        _readOnly: {
          bg: "rgba(226,232,240, 0.2)",
          border: "var(--chakra-colors-chakra-border-color) 1px solid !important",
          cursor: "default",
        },
      },

      // MULTIPART THEMES
      Accordion: accordionTheme,
      Slider: sliderTheme,
      Popover: popoverTheme,
      Checkbox: checkboxTheme,
      Tabs: tabsTheme,
      Menu: menuTheme,
      Modal: modalTheme,
      Input: inputTheme,
      Form: formTheme,
      FormError: formErrorTheme,
      Alert: alertTheme,
      Table: tableTheme,
      Switch: switchTheme,
      Radio: radioTheme,
    },
  });
